// app-subdomain-creators/src/stores/newsfeedInstanceStore.js

import { defineStore } from 'pinia';

const apiProxyUrl = process.env.VUE_APP_API_PROXY_URL;
const headerLoadPromises = new Map();

export const useNewsfeedInstanceStore = defineStore('newsfeedInstance', {
  state: () => ({
    // byId[instanceId] = {
    //   coverMediaId: number | null,        // creator_newsfeed_settings.group_cover_media_id
    //   coverFileId: string | null,         // media_files.file_id (UUID)
    //   coverImageUrl: string | null,       // final URL we actually use in <img>
    //   secureImageUrl: string | null,      // signed S3 URL from backend
    //   groupName: string | null,
    //   loaded: boolean,
    //   loading: boolean,
    // }
    byId: {},
  }),

  actions: {
    ensureEntry(instanceId) {
      const key = String(instanceId);
      if (!this.byId[key]) {
        this.byId[key] = {
          coverMediaId: null,
          coverFileId: null,
          coverImageUrl: null,
          secureImageUrl: null,
          groupName: null,
          loaded: false,
          loading: false,
        };
      }
      return this.byId[key];
    },

    async ensureHeaderLoaded(instanceId, { force = false } = {}) {
      if (!instanceId) return false;

      const entry = this.ensureEntry(instanceId);
      const key = String(instanceId);

      if (!force && entry.loaded) return true;
      if (headerLoadPromises.has(key)) return headerLoadPromises.get(key);

      const loadPromise = (async () => {
        entry.loading = true;
        try {
          const params = new URLSearchParams({
            featureInstanceId: String(instanceId),
          });

          const res = await fetch(
            `${apiProxyUrl}/api/creator-newsfeed/instance-header?${params.toString()}`,
            {
              method: 'GET',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              cache: 'no-store',
            }
          );

          if (!res.ok) {
            throw new Error(`Failed to load header (HTTP ${res.status})`);
          }

          const data = await res.json();

          entry.coverMediaId = data.coverMediaId ?? null;
          entry.coverFileId = data.coverFileId ?? null;
          entry.secureImageUrl = data.secureImageUrl ?? null;

          entry.coverImageUrl =
            data.secureImageUrl ||
            data.coverImageUrl ||
            null;

          entry.groupName = data.groupName ?? null;
          entry.loaded = true;
          return true;
        } catch (err) {
          console.error('[newsfeedInstanceStore] ensureHeaderLoaded error:', err);
          return false;
        } finally {
          entry.loading = false;
          headerLoadPromises.delete(key);
        }
      })();

      headerLoadPromises.set(key, loadPromise);
      return loadPromise;
    },

    setHeader(
      instanceId,
      {
        coverMediaId,
        coverFileId = null,
        coverImageUrl,
        secureImageUrl = null,
        groupName = null,
      }
    ) {
      if (!instanceId) return;
      const entry = this.ensureEntry(instanceId);

      entry.coverMediaId = coverMediaId ?? null;
      entry.coverFileId = coverFileId ?? null;
      entry.secureImageUrl = secureImageUrl ?? null;
      entry.coverImageUrl = coverImageUrl ?? null;
      entry.groupName = groupName;
      entry.loaded = true;
    },
  },
});
